import { useEffect } from 'react';
import { useNavigate } from '@tanstack/react-router';
import { onDeepLink } from '../lib/desktop-bridge';

// ANX-059 — слушает `anexica://` deep-link'и от desktop-shell'а и
// маршрутизирует webview на соответствующую страницу панели.

export function useDesktopDeepLink(): void {
  const navigate = useNavigate();
  useEffect(() => {
    let stop = () => {};
    void onDeepLink((payload) => {
      const link = payload.parsed;
      if (!link) return;
      switch (link.kind) {
        case 'conversation':
          void navigate({ to: '/conversations/$id', params: { id: link.id } });
          return;
        case 'settings':
          void navigate({ to: '/settings' });
          return;
        // 'unknown' — игнорируем, deep-link останется логом в Tauri.
      }
    }).then((unlisten) => {
      stop = unlisten;
    });
    return () => stop();
  }, [navigate]);
}
